import { FormHelperText as NovaFormHelperText, FormHelperTextProps } from '@fme-nova/components'
import { FormHelperText as MuiFormHelperText } from '@mui/material'

import { COLORS, createComponentWrapperWithRef, styled, uiTokens } from '../../theme'

const StyledMuiFormHelperText = styled(MuiFormHelperText)<FormHelperTextProps>`
  ${(props) => props.state === 'error' && `color: ${COLORS.validation.error.main}`}
  ${(props) => props.state === 'warning' && `color: ${COLORS.validation.warning.main}`}
  ${(props) => props.state === 'information' && `color: ${COLORS.validation.info.main}`}
  ${(props) => props.state === 'enabled' && `color: ${COLORS.validation.none.main}`}
`

const StyleNovaFormHelperText = styled(NovaFormHelperText)<FormHelperTextProps>`
  padding: ${uiTokens.spacing.padding.xxSmall}px ${uiTokens.spacing.padding.semiMedium}px 0
    ${uiTokens.spacing.padding.semiMedium}px;
`

export const FormHelperText = createComponentWrapperWithRef<FormHelperTextProps>(
  {
    mui: StyledMuiFormHelperText,
    nova: StyleNovaFormHelperText,
  },
  'FormHelperText',
)

export { type FormHelperTextProps } from '@fme-nova/components'
